<template>
  <AutocompleteSearchControl :search="search" :value="value" @input="$emit('input', $event)"/>
</template>

<script lang="ts">
import {SearchResultItem} from '@/model/api/search';
import TransactionFinder from '@/model/TransactionFinder';
import {defineComponent, inject, PropType} from 'vue';
import AutocompleteSearchControl from '../common/AutocompleteSearchControl.vue';

export default defineComponent({
    components: {AutocompleteSearchControl},
    props: {
        value: {
            type: Object as PropType<SearchResultItem | null>,
            default: null,
        },
    },
    emits: ['input'],
    setup() {
        const finder = inject<TransactionFinder>('transactionFinder')!;

        const search = finder.search.bind(finder);

        return {search};
    },
});
</script>
